import { Link, Outlet, createFileRoute, useRouterState } from '@tanstack/react-router'
import { Skeleton, cx } from '@algoboo/ui'
import { usePageMeta } from '../lib/meta'
import { PageHeader } from '../components/Shell'
import { SignInPrompt, useSession } from '../components/session'
import { Forbidden } from '../components/admin/parts'

export const Route = createFileRoute('/admin')({ component: AdminLayout })

const TABS = [
  { to: '/admin', label: 'Overview' },
  { to: '/admin/agents', label: 'Agents' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/jobs', label: 'Jobs' },
  { to: '/admin/fees', label: 'Fees' },
] as const

/** Operator console shell: signed in, `Me.isAdmin`, then the section tabs. The API enforces the same (403). */
function AdminLayout() {
  usePageMeta('Admin')
  const { me, loading } = useSession()
  const path = useRouterState({ select: (s) => s.location.pathname })
  if (loading) return <Skeleton className="h-64 rounded-xl" />
  if (!me) return <SignInPrompt title="Operator console" body="Sign in with an operator wallet to open the console." />
  if (me.isAdmin === false) return <Forbidden />
  return (
    <div data-testid="admin-console">
      <PageHeader eyebrow="Operator" title="Console" lede="Queue, indexers, spend and the treasury backlog. Actions here are logged with your user id." />
      <nav aria-label="Admin sections" className="-mx-1 mb-6 flex gap-1 overflow-x-auto border-b border-line px-1">
        {TABS.map((t) => {
          const active = t.to === '/admin' ? path === '/admin' || path === '/admin/' : path.startsWith(t.to)
          return (
            <Link
              key={t.to}
              to={t.to}
              aria-current={active ? 'page' : undefined}
              className={cx('-mb-px whitespace-nowrap border-b-2 px-3 py-2 text-[13.5px] font-medium', active ? 'border-accent text-ink' : 'border-transparent text-ink-3 hover:text-ink')}
            >
              {t.label}
            </Link>
          )
        })}
      </nav>
      <Outlet />
    </div>
  )
}
